/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Export_ExcelInputs */

const vi_care_log_export_excel = /** @type {(inputs: Care_Log_Export_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel`)
};

/**

* @param {Care_Log_Export_ExcelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_export_excel = /** @type {((inputs?: Care_Log_Export_ExcelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Export_ExcelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_export_excel(inputs)
});